export const LocalStorageKeys = {
  UpdateZeroKm: "update_zero_km",
};
